import React from 'react';
import { Menu } from 'semantic-ui-react';

const RibbonMenuActions = ({ children, fullscreen }) => (
  <Menu
    className="context aridhia-ribbon-actions"
    compact={fullscreen}
    floated={fullscreen ? undefined : 'right'}
    icon={fullscreen ? undefined : 'labeled'}
  >
    {children}
  </Menu>
);

export default RibbonMenuActions;
